// @ts-ignore
import equal from 'fast-deep-equal';

export const deepEqual = equal;
